import {getCSRFToken} from "@/store/auth";
import {API_BASE_URL} from "@/config";

export async function checkEventCodeUnique(organisationSlug, eventCode) {
    try {
        const response = await fetch(`${API_BASE_URL}/organisations/${organisationSlug}/check-event-code-unique`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken()
            },
            body: JSON.stringify({event_code: eventCode.trim()}),
            credentials: 'include'
        });
        const data = await response.json();
        return data;
    } catch (err) {
        console.error('Error checking event code uniqueness', err);
        return {status: 'error', errors: ['An error occurred. Please try again.']};
    }
}

export async function checkEventNameUnique(organisationSlug, eventName) {
    try {
        const response = await fetch(`${API_BASE_URL}/organisations/${organisationSlug}/check-event-name-unique`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken()
            },
            body: JSON.stringify({event_name: eventName.trim()}),
            credentials: 'include'
        });
        const data = await response.json();
        return data;
    } catch (err) {
        console.error('Error checking event name uniqueness', err);
        return {status: 'error', errors: ['An error occurred. Please try again.']};
    }
}

export async function checkSiteCodeUnique(organisationSlug, siteCode) {
    try {
        const response = await fetch(`${API_BASE_URL}/organisations/${organisationSlug}/check-site-code-unique`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken()
            },
            body: JSON.stringify({site_code: siteCode.trim()}),
            credentials: 'include'
        });
        const data = await response.json();
        return data;
    } catch (err) {
        console.error('Error checking site code uniqueness', err);
        return {status: 'error', errors: ['An error occurred. Please try again.']};
    }
}

export async function checkSiteNameUnique(organisationSlug, siteName) {
    try {
        const response = await fetch(`${API_BASE_URL}/organisations/${organisationSlug}/check-site-name-unique`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken()
            },
            body: JSON.stringify({site_name: siteName.trim()}),
            credentials: 'include'
        });
        const data = await response.json();
        return data;
    } catch (err) {
        console.error('Error checking site name uniqueness', err);
        return {status: 'error', errors: ['An error occurred. Please try again.']};
    }
}